import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { DeliveryStatus } from 'src/app/core/api/models';

@Directive({
  selector: '[deliveryStatusStyle]',
  standalone: true,
})
export class DeliveryStatusDirective implements OnInit {
  @Input('deliveryStatusStyle') deliveryStatus: DeliveryStatus;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.deliveryStatusStyle();
  }

  deliveryStatusStyle(): string {
    // danger
    if (
      [
        DeliveryStatus.ErrorInSending,
        DeliveryStatus.InvalidUserOrPassword,
        DeliveryStatus.InvalidSender,
        DeliveryStatus.InvalidMobile,
        DeliveryStatus.HaveNotReceivedToPhone,
        DeliveryStatus.DidNotReceiveToItc,
        DeliveryStatus.NotReceivebyServer,
        DeliveryStatus.NotSent,
        DeliveryStatus.NotEnoughBalance,
        DeliveryStatus.TextIsEmpty,
        DeliveryStatus.CodingNotSupport,
        DeliveryStatus.OperatorSystemError,
        DeliveryStatus.UdhIsWrong,
        DeliveryStatus.Rejected,
        DeliveryStatus.UserNameNotFound,
        DeliveryStatus.InvalidCoding,
        DeliveryStatus.InvalidGroupPrice,
        DeliveryStatus.InvalidRequest,
        DeliveryStatus.InvalidSendTime,
        DeliveryStatus.InvalidSmsText,
        DeliveryStatus.OperatorNotSupport,
        DeliveryStatus.PrivateNumberIsBlocked,
        DeliveryStatus.SmsIsFilter,
        DeliveryStatus.RejectFromOperator,
      ].includes(this.deliveryStatus)
    )
      return 'text-danger font-weight-500';
    //success
    else if (
      [DeliveryStatus.SentAndReceivedbyPhone].includes(this.deliveryStatus)
    )
      return 'text-success font-weight-500';
    else if (
      [DeliveryStatus.SentToItc, DeliveryStatus.Sent].includes(
        this.deliveryStatus
      )
    )
      return 'text-lime font-weight-500';
    else if ([DeliveryStatus.Stored].includes(this.deliveryStatus))
      return 'text-primary font-weight-500';
    else return '';
  }
}
